import { useEffect, useState } from "react"
import useHttp from "../../../../hooks/use-http"

const ChooseProduct = ({chosenProduct, setProduct}) => {
    const [productList, setProductList] = useState([])


    const {isLoading : formLoading, error : formError, sendRequest : sendForm} = useHttp( (data) =>{
        setProductList(data['results'])
        setProduct(data['results'][0].id)
    })

    useEffect( () => {
        sendForm({url:'/rest/productlisting/list_store/', json:true})
    }, [])
    return (
        (productList.length == 1) ?
            <h6>{productList[0].product_object.name} ({productList[0].product_object.max_people} personen)</h6>
            :
            <select onChange={ (e) => {setProduct(e.target.value)}} class="form-select mb-2 me-auto" aria-label="Default select example">
                {
                productList.map( (product, index) => 
                    <option key={product.id} defaultValue={product.id} selected={product.id===chosenProduct} > 
                        {product.product_object.name} ({product.product_object.max_people} personen)
                    </option>)
                }
            </select>
    )
    
}

export default ChooseProduct